import React from 'react'
import useBankVerificationSuccessPageLogic from './hooks/useBankVerificationSuccessPageLogic'


const BankVerificationSuccessPage = () => {

  useBankVerificationSuccessPageLogic()

  return <div />
}

export default BankVerificationSuccessPage;